import { Component, ErrorInfo, ReactNode } from "react";
import { Button } from "tvs-unified-lib";
import {
  ButtonContainer,
  Container,
  ErrorIcon,
  Message,
  Title,
} from "./styles";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <ErrorIcon>
            <div>!</div>
          </ErrorIcon>
          <Title>Oops! Something went wrong</Title>
          <Message>
            We apologize for the inconvenience. An unexpected error has
            occurred. Please try refreshing the page or return to the home page.
          </Message>
          <ButtonContainer>
            <Button
              onClick={() => window.location.reload()}
              theme="red"
              variant="outline"
              label="Refresh Page"
            />
            <Button
              onClick={() => (window.location.href = "/")}
              theme="red"
              variant="block"
              label="Go to Home"
            />
          </ButtonContainer>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
